<template>
  <div class='sign' :style="'background-image: url('+HOST+bkimg+');padding-top:'+paddingTop+'vh'">
    <div v-if="viewList" class="signdiv listDiv">
      <div v-if="list.length>0">
        <el-row :gutter="10" v-for="(item,index) in list" :key="index">
          <el-col :span="rowWidth" v-for="(i,k) in item" :key="k">{{ i }}</el-col>
        </el-row>
      </div>
      <div v-else>暂无数据</div>
      <div :style="'width:'+width+';margin-left:'+left">
        <el-button type="primary" @click="getList" v-if="viewList" style="width:100%;margin-bottom:10px">刷新
        </el-button>
        <el-button type="primary" @click="baoming" v-if="viewList" style="width:100%;margin-left:0">我要报名</el-button>
      </div>
    </div>
    <div class="signdiv" v-else>
      <div v-if="loading">
        <span style="color:black">加载中，请稍候</span>
      </div>
      <div v-else>
        <div class="text-center" style="font-weight:bold" :style="'color:'+color+';margin-bottom:'+marginBottom+'px'"
             v-if="time!==''">报名截止倒计时：<br/><span :style="'color:'+color2">{{ time }}</span></div>
        <!--        <div :style="'width:'+width+';margin-left:'+left">-->
        <!--          <el-form label-width="100px">-->
        <!--            <el-form-item v-for="(item,index) in info" :key="index" :label="item.title">-->
        <!--              <el-input size="mini" v-model="item.detail" v-if="item.type=='input'" :placeholder="item.placeholder==''?'请输入'+item.title:item.placeholder"></el-input>-->
        <!--              <el-select v-model="item.detail" :placeholder="item.placeholder==''?'请选择'+item.title:item.placeholder" size='mini' v-if="item.type=='select'" style="width:100%">-->
        <!--                <el-option v-for="(i, k) in item.select" :key="k" :label="i.title" :value="k"></el-option>-->
        <!--              </el-select>-->
        <!--            </el-form-item>-->
        <!--          </el-form>-->
        <!--        </div>-->
        <div :style="'width:'+width+';margin-left:'+left">
          <div class="baoming-item" :style="'margin-bottom:'+marginBottom+'px'">
            <div class="baoming-item-title">姓名</div>
            <div class="baoming-item-detail">
              <el-input size="mini" v-model="name" placeholder="请输入您的姓名"></el-input>
            </div>
          </div>
          <div v-for="(item,index) in info" :key="index" class="baoming-item"
               :style="'margin-bottom:'+marginBottom+'px'">
            <div class="baoming-item-title">{{ item.title }}</div>
            <div class="baoming-item-detail">
              <el-input size="mini" v-model="item.detail" v-if="['input','tel'].includes(item.type)"
                        :placeholder="item.placeholder===''?'请输入'+item.title:item.placeholder"></el-input>
              <el-select v-model="item.detail" :placeholder="item.placeholder===''?'请选择'+item.title:item.placeholder"
                         size='mini' v-if="item.type==='select'" style="width:100%">
                <el-option v-for="(i, k) in item.select" :key="k" :label="i.title" :value="k"></el-option>
              </el-select>
            </div>
          </div>
          <el-button type='primary' @click="sign" style="width:100%;margin-bottom:10px">提交</el-button>
          <!--          <el-button type="primary" @click="showList" v-if="viewList==false" style="width:100%;margin-left:0">查看报名人员</el-button>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      info: [],
      slctDep: '',
      openid: '',
      avator: '',
      bkimg: '',
      endtime: '',
      time: "",
      width: '60%',
      color: 'white',
      color2: 'red',
      marginBottom: 20,
      paddingTop: 10,
      viewList: false,
      loading: true,
      name: ''
    };
  },
  mounted() {
    // this.request();
  },
  computed: {
    left() {
      return (100 - parseInt(this.width)) / 2 + '%'
    },
    rowWidth() {
      if (this.list.length > 0) {
        return parseInt(24 / this.list[0].length);
      } else {
        return 4;
      }
    }
  },
  methods: {
    baoming() {
      this.viewList = false;
    },
    getList() {
      this.$axios({
        url: this.HOST + '/member.login/getList',
        method: 'post',
        data: {}
      }).then(res => {
        if (res.data.status == 1) {
          this.list = res.data.list;
        }
      });
    },
    showList() {
      this.getList();
      this.viewList = true;
    },
    getUrlKey(name) {//获取url 参数
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
    },
    sign() {
      if (this.name === '') {
        this.$message({
          type: 'error',
          message: "请填写您的姓名"
        })
        return;
      }
      let data = [];
      for (let item in this.info) {
        let crntinfo = this.info[item];
        if (crntinfo.detail === '') {
          this.$message({
            type: 'error',
            message: "请填写" + crntinfo.title
          })
          return;
        }
        data.push(crntinfo);
      }
      this.$axios({
        url: this.HOST + '/member.login/sign',
        method: 'post',
        data: {
          openid: this.openid,
          info: data,
          name: this.name,
        }
      }).then(res => {
        if (res.data.status == 1) {
          this.$alert('报名成功', '友情提示', {
            confirmButtonText: '确定'
          })
        }
      });
    },
    login(code = '') {
      this.$axios({
        url: this.HOST + '/member.login/login',
        method: 'post',
        data: {
          code: code,
          openid: this.openid,
          url: location.href.split("#")[0],
        }
      }).then(res => {
        this.loading = false;
        if (res.data.status === 1) {
          this.title = res.data.title;
          this.bkimg = res.data.bkimg;
          this.width = res.data.width;
          this.marginBottom = res.data.marginbottom;
          this.color = res.data.color;
          this.color2 = res.data.color2;
          this.paddingTop = res.data.margintop;
          document.title = res.data.webname;
          if (res.data.successinfo) {
            this.successinfo = res.data.successinfo;
          } else {
            this.openid = res.data.openid;
            sessionStorage.setItem('openid', this.openid);
            this.info = res.data.info;
            if (res.data.name) {
              this.name = res.data.name;
            }
            setInterval(() => {
              let crnt = Date.now();
              crnt = parseInt(crnt / 1000);
              crnt = res.data.endtime - crnt;
              let temp = '';
              if (crnt > 86400) {
                temp = parseInt(crnt / 86400) + '天';
                crnt = crnt % 86400;
              }
              if (crnt > 3600) {
                temp += parseInt(crnt / 3600) + '小时';
                crnt = crnt % 3600;
              }
              if (crnt > 60) {
                temp += parseInt(crnt / 60) + '分钟';
                crnt = crnt % 60;
              }
              temp += crnt + '秒';
              this.time = temp;
            }, 1000);
          }
          wx.config({
            debug: false,
            appId: res.data.configInfo.appId,
            timestamp: res.data.configInfo.timestamp,
            nonceStr: res.data.configInfo.noncestr,
            signature: res.data.configInfo.signature,
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
          });
          wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
            wx.updateAppMessageShareData({
              title: res.data.shareInfo.title, // 分享标题
              desc: res.data.shareInfo.desc, // 分享描述
              link: window.location.origin, // 分享链接，该链接域名或路径必须与当前页面对应的服务号JS安全域名一致
              imgUrl: window.baseUrl+res.data.shareInfo.imgUrl, // 分享图标
              success: function () {
                // 设置成功
              }
            })
          });
        }
      });
    }
  },
  created() {
    this.openid = sessionStorage.getItem('openid');
    let code = this.getUrlKey('code');
    if (this.openid) {
      if (code) {
        location.href = window.location.origin;
      } else {
        this.login()
      }
    } else {
      if (code) {
        this.login(code);
      } else {
        // let url = 'http://auth.qlsww.com/auth/get?license=baoming';
        let url = 'http://auth.qlsww.com/auth/get?license=weichang';
        // let url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxefc403f992b130a4&redirect_uri=" + window.location.href + "&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect";
        window.location.replace(url)
      }
    }
  }
};
</script>